import { FC } from "react"
import { LoanOfficer } from "../../../../types"
import htmlToDraft from "html-to-draftjs"
import GoogleReviewsList from "../../google-reviews-list"
import If from "../../if"
import { useFetchBrandReviewsQuery } from "../../../../redux/queries"

interface Props {
  loanOfficer: LoanOfficer
}

const LoanOfficerOverview: FC<Props> = ({ loanOfficer }) => {
  const { data: reviews } = useFetchBrandReviewsQuery(
    {
      place_id: loanOfficer?.google_place_id ?? ""
    },
    {
      skip: !loanOfficer || !loanOfficer?.google_place_id
    }
  )

  return (
    <div>
      <div className="flex pb-6">
        <div className="flex-1">
          <div className="text-neutral-400">Title</div>
          <div className="text-neutral-800">{loanOfficer.position}</div>
        </div>
        <div className="flex-1">
          <div className="text-neutral-400">NMLS</div>
          <div className="text-neutral-800">{loanOfficer.nmls ?? "-"}</div>
        </div>
      </div>

      <div className="flex pb-6">
        <div className="flex-1">
          <div className="text-neutral-400">Pricing engine</div>
          <div className="text-neutral-800">{loanOfficer.pricing_status}</div>
        </div>
      </div>

      <div className="flex pb-6">
        <div className="flex-1">
          <div className="text-neutral-400">Mobile number</div>
          <div className="text-neutral-800">
            {loanOfficer.mobile_phone ?? "-"}
          </div>
        </div>
        <div className="flex-1">
          <div className="text-neutral-400">Office number</div>
          <div className="text-neutral-800">
            {loanOfficer.office_phone ?? "-"}
          </div>
        </div>
      </div>

      <div className="flex pb-6">
        <div className="flex-1">
          <div className="text-neutral-400">
            Primary phone number (optional)
          </div>
          <div className="text-neutral-800">{loanOfficer.phone ?? "-"}</div>
        </div>
      </div>

      <div className="flex pb-6">
        <div className="flex-1">
          <div className="text-neutral-400">Pre app link</div>
          <div className="text-neutral-800">{loanOfficer.app_link ?? "-"}</div>
        </div>
      </div>

      <div className="flex pb-6">
        <div className="flex-1">
          <div className="text-neutral-400">Special disclosure link</div>
          <div className="text-neutral-800">
            {loanOfficer.special_disclosure_link ?? "-"}
          </div>
        </div>
      </div>

      <div className="pb-6">
        <div className="text-neutral-400">About me</div>
        <div className="text-neutral-800">
          {loanOfficer.about_me
            ? htmlToDraft(loanOfficer.about_me)
                .contentBlocks.map(b => b.getText())
                .join(" ")
            : "-"}
        </div>
      </div>

      <div className="pb-6">
        <div className="text-lg font-medium">Social</div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">Facebook link</div>
        <div className="text-neutral-800">
          {loanOfficer.facebook_link ?? "-"}
        </div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">Linkedin link</div>
        <div className="text-neutral-800">
          {loanOfficer.linkedin_link ?? "-"}
        </div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">Calendly link</div>
        <div className="text-neutral-800">
          {loanOfficer.calendly_link ?? "-"}
        </div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">Instagram link</div>
        <div className="text-neutral-800">
          {loanOfficer.instagram_link ?? "-"}
        </div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">YouTube link</div>
        <div className="text-neutral-800">
          {loanOfficer.youtube_link ?? "-"}
        </div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">Website link</div>
        <div className="text-neutral-800">
          {loanOfficer?.website_link ?? "-"}
        </div>
      </div>
      <div className="pb-6">
        <div className="text-lg font-medium">Office</div>
      </div>
      <div className="pb-6">
        <div className="text-neutral-400">Office address</div>
        <div className="text-neutral-800">
          {loanOfficer.office_street_addr ?? "-"}
        </div>
      </div>

      <div className="pb-6">
        <div className="text-neutral-400">Branch NMLS</div>
        <div className="text-neutral-800">{loanOfficer.branch_nmls ?? "-"}</div>
      </div>
      <If
        condition={!!loanOfficer?.google_place_id}
        then={
          <div className="pb-6">
            <div className="text-neutral-400">Google reviews</div>
            <div className="text-neutral-800">
              <GoogleReviewsList
                placeId={loanOfficer?.google_place_id ?? ""}
                hideTitle
                reviews={reviews?.google}
              />
            </div>
          </div>
        }
      />
    </div>
  )
}

export default LoanOfficerOverview
